import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminGiftCards() {
  const [items, setItems] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [redeemFor, setRedeemFor] = useState(null);
  const [redemption, setRedemption] = useState({ amount: 0, description: "", associate_id: "" });

  const load = async () => {
    const { data } = await api.get("/giftcards");
    setItems(data);
  };
  useEffect(() => {
    load();
    api.get("/associates").then(({ data }) => setAssociates(data));
  }, []);

  const redeem = async () => {
    try {
      await api.post("/giftcards/redeem", {
        code: redeemFor.code,
        amount: parseFloat(redemption.amount),
        description: redemption.description,
        associate_id: redemption.associate_id || undefined,
      });
      toast.success("Bescanviat"); setRedeemFor(null); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-giftcards">
      <div>
        <div className="overline text-accent">Vals</div>
        <h1 className="mt-2 text-3xl font-heading font-bold tracking-tight">Targetes Regal</h1>
      </div>

      <Card className="rounded-2xl border-2 overflow-hidden">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Codi</TableHead><TableHead>Inicial</TableHead><TableHead>Saldo</TableHead>
                <TableHead>Estat</TableHead><TableHead>Destinatari</TableHead><TableHead>Data</TableHead><TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((g) => (
                <TableRow key={g.id} data-testid={`giftcard-row-${g.code}`}>
                  <TableCell className="font-mono text-xs">{g.code}</TableCell>
                  <TableCell>{g.initial_amount.toFixed(2)} €</TableCell>
                  <TableCell className="font-semibold">{g.current_balance.toFixed(2)} €</TableCell>
                  <TableCell><span className={`text-xs px-2 py-1 rounded-full ${g.status === "active" ? "bg-emerald-100 text-emerald-700" : "bg-muted"}`}>{g.status}</span></TableCell>
                  <TableCell className="text-sm">{g.recipient_name}<br /><span className="text-xs text-muted-foreground">{g.recipient_email}</span></TableCell>
                  <TableCell className="text-xs">{new Date(g.created_at).toLocaleDateString()}</TableCell>
                  <TableCell>
                    {g.status === "active" && (
                      <Dialog>
                        <DialogTrigger asChild>
                          <Button size="sm" variant="outline" className="rounded-full" onClick={() => { setRedeemFor(g); setRedemption({ amount: g.current_balance, description: "", associate_id: "" }); }} data-testid={`giftcard-redeem-${g.code}`}>Bescanviar</Button>
                        </DialogTrigger>
                        <DialogContent>
                          <DialogHeader><DialogTitle>Bescanviar {g.code}</DialogTitle></DialogHeader>
                          <div className="space-y-3">
                            <div><Label>Import (màx {g.current_balance.toFixed(2)} €)</Label><Input type="number" step="0.01" max={g.current_balance} value={redemption.amount} onChange={(e) => setRedemption({ ...redemption, amount: e.target.value })} /></div>
                            <div><Label>Comerç associat</Label>
                              <select className="w-full mt-1 rounded-lg border px-3 py-2" value={redemption.associate_id} onChange={(e) => setRedemption({ ...redemption, associate_id: e.target.value })}>
                                <option value="">(cap)</option>
                                {associates.map((a) => <option key={a.id} value={a.id}>{a.commercial_name}</option>)}
                              </select>
                            </div>
                            <div><Label>Descripció</Label><Input value={redemption.description} onChange={(e) => setRedemption({ ...redemption, description: e.target.value })} /></div>
                          </div>
                          <DialogFooter><Button onClick={redeem}>Confirmar</Button></DialogFooter>
                        </DialogContent>
                      </Dialog>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {items.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-8 text-muted-foreground">Sense targetes.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
